"use strict";

exports.__esModule = true;
exports.isSupportedWidgetProperty = isSupportedWidgetProperty;
/**
 * Determine whether a widget supports the given property.
 */
function isSupportedWidgetProperty(widget, property) {
  return widget.optionalProps.includes(property) || widget.requiresProps.includes(property);
}